module.exports = __webpack_public_path__ + "img/placas.f8bb720a.svg";